import React, { useEffect, useState } from 'react'
import Hamilton from './hamilton'
import MauriceLacroix from './MauriceLacroix'

import Tissot from './tissot'
import FrederiqueConstant from './FrederiqueConstant'
import Junghans from './Junghans'
import Oris from './Oris'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min'
import MovadoPage from './movadoPage'

const WatchesLanding = () => {
  const { brand } = useParams();
  const [selectedBrand, setSelectedBrand] = useState(null);

  // Whenever brand changes (from URL), update state
  useEffect(() => {
    setSelectedBrand(brand);
  }, [brand]);

  return (
    <>
      {selectedBrand === "ORIS" ? <Oris /> :
      selectedBrand === "Tissot" ? <Tissot /> :
      selectedBrand === "HAMILTON" ? <Hamilton /> :
      selectedBrand === "Junghans" ? <Junghans /> :
      selectedBrand === "Movado brands" ? <MovadoPage /> :
      selectedBrand === "MAURICE-LACROIX" ? <MauriceLacroix /> :
      selectedBrand === "Frederique Constant" ? <FrederiqueConstant /> :
      null}
    </>
  );
};


export default WatchesLanding
